// This file contains the initial data for the complaints page.
// It's used by the dataUploader script to seed the Firestore database.

export const reportTitle = "Data for the month ending May 2025";

export const ComplaintData = [
    {
        SI_No: "1",
        Received_from: "Directly from Investors",
        Pending_at_the_end_of_last_month: 0,
        Received: 0,
        Resolved: 0,
        Total_Pending: 0,
        Pending_Complaints_Over_3_months: 0,
        Average_Resolution_Time: 0
    },
    {
        SI_No: "2",
        Received_from: "SEBI (Scores)",
        Pending_at_the_end_of_last_month: 0,
        Received: 0,
        Resolved: 0,
        Total_Pending: 0,
        Pending_Complaints_Over_3_months: 0,
        Average_Resolution_Time: 0
    },
    {
        SI_No: "3",
        Received_from: "Other Sources",
        Pending_at_the_end_of_last_month: 0,
        Received: 0,
        Resolved: 0,
        Total_Pending: 0,
        Pending_Complaints_Over_3_months: 0,
        Average_Resolution_Time: 0
    },
];

export const trendData = [
    {
      "sl_no": "1", "month": "December 2024", "carried_forward": 0, "received": 0, "resolved": 0, "pending": 0
    },
    {
      "sl_no": "2", "month": "January 2025", "carried_forward": 0, "received": 0, "resolved": 0, "pending": 0
    },
    {
      "sl_no": "3", "month": "February 2025", "carried_forward": 0, "received": 0, "resolved": 0, "pending": 0
    },
    {
      "sl_no": "4", "month": "March 2025", "carried_forward": 0, "received": 0, "resolved": 0, "pending": 0
    },
    {
        "sl_no": "5", "month": "April 2025", "carried_forward": 0, "received": 0, "resolved": 0, "pending": 0
    },
    {
        "sl_no": "6", "month": "May 2025", "carried_forward": 0, "received": 0, "resolved": 0, "pending": 0
    }
];

export const annualTrendData = [
  {
    "sl_no": "1", "year": "2023-24", "carried_forward": 0, "received": 0, "resolved": 0, "pending": 0
  },
  {
    "sl_no": "2", "year": "2024-25", "carried_forward": 0, "received": 0, "resolved": 0, "pending": 0
  }
];

export const escalationData = [
  {
    designation: "Customer Care", contact_person: "Shreyas/Ritu", address: "1008, 3rd Floor, 7th A Main, Koramangala 1st Block, Bengaluru 560034", contact_no: "+91-6363219981", email: "care@rightspade.com", working_hours: "Mon to Friday, 10:00 am to 4:00 pm"
  },
  {
    designation: "Compliance Officer", contact_person: "Shreyas Pandit", address: "1008, 3rd Floor, 7th A Main, Koramangala 1st Block, Bengaluru 560034", contact_no: "+91-9845004645", email: "shreyas@rightspade.com", working_hours: "Mon to Friday, 4:00 pm to 7:00 pm"
  },
  {
    designation: "Director", contact_person: "Shreyas Pandit", address: "1008, 3rd Floor, 7th A Main, Koramangala 1st Block, Bengaluru 560034", contact_no: "+91-9845004645", email: "shreyas@rightspade.com", working_hours: "Mon to Friday, 4:00 pm to 7:00 pm"
  },
  {
    designation: "Principal Officer", contact_person: "Ritu Sharma", address: "1008, 3rd Floor, 7th A Main, Koramangala 1st Block, Bengaluru 560034", contact_no: "+91-9972168800", email: "ritu@rightspade.com", working_hours: "Mon to Friday, 4:00 pm to 7:00 pm"
  }
]; 